<div class="button is-outlined" [ngClass]="iconColor" role="button"
    tooltipPosition="bottom" pTooltip="{{iconDescription}}" [attr.disabled]="disabled ? 'disabled' : undefined">
    <span class="icon">
        <fa-icon *ngIf="iconDefinition" [icon]="iconDefinition"></fa-icon>
    </span>
</div>
<span class="is-sr-only">
    {{iconText}}
</span>
